import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_have_any_of_the_following_safety_measures_in_place_8'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_have_any_of_the_following_safety_measures_in_place_8',
  name: 'Does the facility have any of the following safety measures in place related to compressed gas cylinders?',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'ALL_COMPRESSED_GAS_CYLINDERS_ARE_SECURE_FROM_ACCIDENTAL_TIPPING',
      text: 'All compressed gas cylinders are secure from accidental tipping/falling',
      externalIds: [
        {
          id: 'hs-28--1-1x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'ALL_COMPRESSED_GAS_CYLINDERS_HAVE_CLOSED_VALVES_WHEN_NOT_IN_USE',
      text: 'All compressed gas cylinders have closed valves when not in use',
      externalIds: [
        {
          id: 'hs-28--1-2x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'COMPRESSED_GAS_CYLINDERS_ARE_TRANSPORTED_SAFELY',
      text: 'Compressed gas cylinders are transported safely',
      externalIds: [
        {
          id: 'hs-28--1-3x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'COMPRESSED_GAS_CYLINDERS_ARE_STORED_AWAY_FROM_HEAT_AND_OTHER_FI',
      text: 'Compressed gas cylinders are stored away from heat and other fire sources',
      externalIds: [
        {
          id: 'hs-28--1-4x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'COMPRESSED_GAS_CYLINDERS_ARE_ONLY_USED_BY_QUALIFIED_WORKERS',
      text: 'Compressed gas cylinders are only used by qualified workers',
      externalIds: [
        {
          id: 'hs-28--1-5x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'COMPRESSED_GAS_CYLINDERS_ARE_LABELED_AND_SEGREGATED',
      text: 'Compressed gas cylinders are labeled and segregated',
      externalIds: [
        {
          id: 'hs-28--1-6x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'COMPRESSED_GAS_CYLINDERS_ARE_STORED_IN_AN_ENCLOSED_CAGE',
      text: 'Compressed gas cylinders are stored in an enclosed cage',
      externalIds: [
        {
          id: 'hs-28--1-7x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'STATIONARY_COMPRESSED_GAS_CYLINDERS_ARE_CONNECTED_WITH_FIXED_PI',
      text: 'Stationary compressed gas cylinders are connected with fixed piping',
      externalIds: [
        {
          id: 'hs-28--1-8x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NONE_OF_THE_ABOVE',
      text: 'None of the above',
      externalIds: [
        {
          id: 'hs-28--1-9x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'ALL_COMPRESSED_GAS_CYLINDERS_ARE_SECURE_FROM_ACCIDENTAL_TIPPING',
                'ALL_COMPRESSED_GAS_CYLINDERS_HAVE_CLOSED_VALVES_WHEN_NOT_IN_USE',
                'COMPRESSED_GAS_CYLINDERS_ARE_TRANSPORTED_SAFELY',
                'COMPRESSED_GAS_CYLINDERS_ARE_STORED_AWAY_FROM_HEAT_AND_OTHER_FI',
                'COMPRESSED_GAS_CYLINDERS_ARE_ONLY_USED_BY_QUALIFIED_WORKERS',
                'COMPRESSED_GAS_CYLINDERS_ARE_LABELED_AND_SEGREGATED',
                'COMPRESSED_GAS_CYLINDERS_ARE_STORED_IN_AN_ENCLOSED_CAGE',
                'STATIONARY_COMPRESSED_GAS_CYLINDERS_ARE_CONNECTED_WITH_FIXED_PI',
                'NONE_OF_THE_ABOVE',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-che-6',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 15530,
  sectionId: '2.2.9.5',
  impactArea: 'Chemicals and Hazardous Substances',
  impactAreaId: 'CHEMICALS_AND_HAZARDOUS_SUBSTANCES',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
